import { render, staticRenderFns } from "./TasksPage.vue?vue&type=template&id=15b19f50&scoped=true&lang=pug&"
import script from "./TasksPage.vue?vue&type=script&lang=js&"
export * from "./TasksPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b19f50",
  null
  
)

export default component.exports